<template>
  <div>
    <b-card
      v-if="isCard"
      no-body
      class="pb-1"
    >
      <b-card-header v-if="chartTitle">
        <b-card-title class="d-block w-100">
          {{ chartTitle }}
        </b-card-title>
        <b-card-sub-title
          v-if="chartSubTitle"
          class="d-block w-100 pt-1"
        >
          {{ chartSubTitle }}
        </b-card-sub-title>
      </b-card-header>
      <vue-apex-charts
        :type="chartType"
        :options="chartOptions"
        :series="seriesData"
      />
    </b-card>
    <div
      v-else
    >
      <vue-apex-charts
        :type="chartType"
        :options="chartOptions"
        :series="seriesData"
      />
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import {
  BCard, BCardHeader, BCardTitle, BCardSubTitle,
} from 'bootstrap-vue'

export default {
  name: 'SimplePieCard',
  components: {
    VueApexCharts, BCard, BCardHeader, BCardTitle, BCardSubTitle,
  },
  props: {
    isCard: {
      type: Boolean,
      default: true,
    },
    chartType: {
      type: String,
      default: 'pie',
    },
    chartTitle: {
      type: String,
      default: null,
    },
    chartSubTitle: {
      type: String,
      default: null,
    },
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
    colorsData: {
      type: Array,
      default: null,
    },
    legendShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: this.chartType,
        },
        labels: this.categoriesData,
        breakpoint: 0,
        legend: {
          show: this.legendShow,
          position: 'bottom',
          fontSize: '14px',
          fontFamily: 'Montserrat',
        },
        // colors: this.colorsData ? this.colorsData : null,
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  fontSize: '16px',
                  fontWeight: 'Bold',
                  fontFamily: 'Montserrat',
                },
                value: {
                  fontSize: '14px',
                  fontWeight: 'Bold',
                  fontFamily: 'Montserrat',
                  formatter(val) {
                    // eslint-disable-next-line radix
                    return `${parseInt(val)}`
                  },
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter(val) {
            // eslint-disable-next-line radix
            return `${parseInt(val)}%`
          },
        },
        responsive: [
          {
            breakpoint: 992,
            options: {
              chart: {
                height: 380,
              },
              legend: {
                show: true,
                position: 'bottom',
              },
            },
          },
          {
            breakpoint: 576,
            options: {
              chart: {
                height: 320,
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        fontSize: '1.5rem',
                      },
                      value: {
                        fontSize: '1rem',
                      },
                      total: {
                        fontSize: '1.5rem',
                      },
                    },
                  },
                },
              },
              legend: {
                show: true,
              },
            },
          },
        ],
      },
    }
  },
  watch: {
    colorsData: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      if (this.colorsData) {
        this.chartOptions.colors = this.colorsData
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
